module.exports = __webpack_public_path__ + "static/media/iconDownloadStepHorizonalDone.cbfff46e.svg";